<template>
    <div class="action-table">
        <v-client-table
            :data="tableData"
            :columns="columns"
            :options="options"
            ref="table"
        >
            <colored-letter-square
                slot="cls_column"
                slot-scope="props"
                :name="props.row.name"
                :length="2"
            >
            </colored-letter-square>

            <div slot="name" slot-scope="props">
                {{ props.row.name }}
            </div>
            <div slot="tenant" slot-scope="props">
                {{ props.row.tenant_name }}
            </div>

            <div slot="actions" slot-scope="props">
                <GlobalSearchActions
                    :data="props.row"
                    :index="props.index"
                    :url="route('tenant.clients.index')"
                ></GlobalSearchActions>
            </div>
        </v-client-table>
    </div>
</template>

<script>
import { Event } from 'vue-tables-2';
import { EventBus } from '../eventbus';

export default {
    data() {
        return {
            tableData: [],
            columns: ['cls_column', 'name', 'tenant', 'actions'],
            options: {
                headings: {
                    cls_column: '',
                    name: this.trans('global_search.clienttable.label.name'),
                    tenant: this.trans(
                        'global_search.clienttable.label.tenant'
                    ),
                    actions: this.trans('vuetables.label.actions'),
                },

                texts: {
                    count: this.trans('vuetables.label.countText'),
                    noResults: this.trans('vuetables.label.noResults'),
                },

                sortable: ['tenant'],
            },
        };
    },

    mounted() {
        EventBus.$on('globalSearchClient', inputClient => {
            axios
                .post('/api/main/global-search/client', {
                    input_client: inputClient,
                })
                .then(data => {
                    this.tableData = data.data.data;
                });
        });
    },
};
</script>
